import { type Inline } from '@atlaskit/adf-schema';

/**
 * Formats URLs as document nodes with spaces between them.
 * Each URL becomes a node, separated by text nodes containing spaces.
 *
 * @param urls - Array of URLs to format as nodes
 * @returns Array of URL nodes interspersed with space text nodes
 */
export const formatUrlsAsNodes = (urls: string[]): Inline[] => {
	const nodes: Inline[] = [];

	urls.forEach((url, index) => {
		// Add the URL node
		nodes.push({
			type: 'inlineCard',
			attrs: { url },
		});

		// Add a space between URLs (but not after the last one)
		if (index < urls.length - 1) {
			nodes.push({
				type: 'text',
				text: ' ',
			});
		}
	});

	return nodes;
};
